import React, { useState, useEffect } from "react";
import styles from "./soil.module.css";

const SoilModal = ({  selectedData, setSelectedParameter , selectedAttribute,polylineData}) => {

  const [selectedParameter, setLocalSelectedParameter] = useState(selectedAttribute); // State to store the selected parameter

  // Handle parameter selection

  const handleSelection = (option) => {
    setLocalSelectedParameter(option);
  };

  return (
    <div className={`md:mt-5 bg-base-100 h-full w-full p-4 rounded-md border overflow-y-auto ${styles.coustomScrollBar}`}>
      <div>
        <div className="overflow-hidden">
          <div className="flex justify-between items-center flex-wrap">
            <h2 className="text-lg text-slate-400 md:text-xl 2xl:text-2xl font-semibold">
              {(selectedData !== null)? `Device ID: ${selectedData.selectedDevice}` : "Select a device"}
            </h2>
          </div>

          {/* Show data for the selected date if available */}
          {selectedData ? (
            <div className="mt-4">
              <div className="bg-white p-4 rounded shadow-md mb-4">
                <p className="font-bold">Record for {selectedData.selectedDate}</p>

                {/* Dropdown to select a parameter */}
                <div className="mt-2">
                  <label htmlFor="parameter-select" className="font-semibold">Select Parameter:</label>
                  <select
                    id="parameter-select"
                    name="options"
                    value={selectedParameter}
                    onChange={(e) => {
                      handleSelection(e.target.value);
                      setSelectedParameter(e.target.value);
                    }}
                    className="ml-2 p-1 border rounded"
                  >
                    <option value="">Select...</option>
                    <option value="pH">PH</option>
                    <option value="conductivity">EC</option>
                    <option value="moisture">Moisture</option>
                    <option value="nitrogen">N</option>
                    <option value="phosphor">P</option>
                    <option value="potassium">K</option>
                  </select>
                </div>
              </div>
            </div>
          ) : (
            <div className="mt-4">
              <p>Please select a date to view its data.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SoilModal;
